import classnames from '../utils/classnames';

const Card = ({ title, titleIcon, children, className = '', controls }) => {
    return (
        <div
            className={classnames(
                'rounded-xl flex flex-col gap-5 py-4 px-5 border border-line-weak border-solid bg-surface-weak shadow-sm',
                className
            )}
        >
            <div className="flex flex-col gap-2">
                <div className="flex flex-row gap-2 items-center justify-between">
                    <div className="flex flex-row gap-2 items-center">
                        {titleIcon}
                        {title && <h3 className="text-sm font-medium text-content-strong">{title}</h3>}
                    </div>
                    {controls && <div className="flex-shrink-0">{controls}</div>}
                </div>

                {children}
            </div>
        </div>
    );
};

export default Card;
